var disposed = false
var Component = require("!../../ream/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../ream/node_modules/vue-loader/lib/selector?type=script&index=0!./v2.6.2-126.vue"),
  /* template */
  require("!!../../ream/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7ac6b8f8\"}!../../ream/node_modules/vue-loader/lib/selector?type=template&index=0!./v2.6.2-126.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/v2.6.2-126.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] v2.6.2-126.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ac6b8f8", Component.options)
  } else {
    hotAPI.reload("data-v-7ac6b8f8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader!./~/v-markdown-loader/_cache/v2.6.2-126.vue
// module id = 1909
// module chunks = 261